import React from "react"
import { User } from "firebase/auth"
import { useForm } from "react-hook-form"
import { LiveId, SelectionId, SpaceKey } from "popopo-msg"
import { api } from "../../core"

export const SelectionFinishForm = (props: {
  firebase: User;
  spaceKey: SpaceKey;
  liveId: LiveId;
  selectionId: SelectionId;
}) => {
  const form = useForm({
    mode: "onBlur",
  })

  const onSelectionDelete = async () => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.DELETE("/api/v2/spaces/{space_key}/lives/{live_id}/selections/{selection_id}", {
        params: { path: { space_key: props.spaceKey, live_id: props.liveId, selection_id: props.selectionId, } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <form className="d-flex flex-column gap-3 w-100">
        <button type="button" className="btn btn-danger form-control" onClick={form.handleSubmit(onSelectionDelete)}>
          Finish Selection
        </button>
      </form>
    </>
  )
}
